"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'Utoniq',
    organizationId: 'W2Ubo9vhm7ouvXSv9W9p',
    applicationKey: 'utoniq',
    applicationType: 'organization',
    artistId: undefined,
    version: '3.0',
    ionicAppId: 'a60f53e0',
    platform: ['web', 'native'],
    ios: {
        bundleId: 'com.utoniq.utoniq',
        appId: '1448888446',
    },
    android: {
        bundleId: 'com.utoniq',
    },
    deeplinkUrl: 'https://app.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/2299305',
    dynamicLinkPrefix: 'utoniqapp',
    applink: 'utoniq.com',
    deeplinkStg: 'utoniq-stg.netlify.app',
    deeplinkProd: 'app.utoniq.com',
    custom: {
        modules: {
            tutorial: true,
            membership: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            nft: true,
            liveStream: true,
            item: true,
            store: true,
            mission: true,
            cart: true,
            konbiniPayment: true,
            event: false, // @note 一般解放を防ぐため、オフにする（会計関連の問題がなければ一般解放）
            preSale: true,
            resale: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: ['home', 'notifications', 'artist', 'myProfile'],
        artistTabs: ['home', 'posts', 'threads'],
    },
});
